import React from 'react'
import { styled } from '@mui/material'
import Machine from '../../../assets/machine-1.png'
import { getDisplayName } from '../../../utils/common.utils'
import { useDashboardGlobalStateContext } from '../../../context/DashboardGlobalStateContext'

const CardContainer = styled('div')(() => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(100px, 1fr))',
  gap: '24px',
  justifyItems: 'center',
  padding: '16px'
}))

const CardWrapper = styled('div')(({ isActive }) => ({
  width: '100px',
  height: '100px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '12px',
  position: 'relative',
  backgroundColor: !isActive ? 'red' : 'transparent',
  overflow: 'hidden',
  cursor: 'default',
  '&::before': {
    content: '""',
    position: 'absolute',
    inset: '-2px',
    borderRadius: '12px',
    backgroundImage: isActive
      ? 'conic-gradient(lightgreen, lightgreen)'
      : 'conic-gradient(transparent, transparent)'
  },
  '&::after': {
    content: '""',
    position: 'absolute',
    inset: '3px',
    borderRadius: '10px',
    backgroundColor: '#fff',
    zIndex: 1
  },
  '& img': {
    zIndex: 2,
    width: '80px',
    height: '50px'
  },
  '& p': {
    zIndex: 2,
    marginTop: '6px',
    fontSize: '12px',
    fontWeight: 700,
    color: '#000',
    textAlign: 'center',
    whiteSpace: 'nowrap'
  }
}))

const LiveMachineList = ({ machineData }) => {
  const { machines: machineOptions } = useDashboardGlobalStateContext()

  const sortedData = [...machineData].sort((a, b) => {
    const aActive = a.machineStatus === true || a.machineStatus === 1
    const bActive = b.machineStatus === true || b.machineStatus === 1

    if (aActive !== bActive) return bActive - aActive

    const aName = getDisplayName(a.machine, machineOptions)?.toLowerCase() || ''
    const bName = getDisplayName(b.machine, machineOptions)?.toLowerCase() || ''
    return aName.localeCompare(bName)
  })

  return (
    <CardContainer>
      {sortedData.length > 0 &&
        sortedData.map((machine) => (
          <CardWrapper
            key={machine.machine}
            isActive={
              machine.machineStatus === true || machine.machineStatus === 1
                ? false
                : true
            }
          >
            <img src={Machine} alt="Machine" />
            <p>{getDisplayName(machine.machine, machineOptions)}</p>
          </CardWrapper>
        ))}
    </CardContainer>
  )
}

export default LiveMachineList
